/*
 * window.MI_CONFIG -> config global inyectada por el tema/merchant para esta seccion
 *   (velocidad de marquee, textos, etc. La usan los helpers de abajo.)
 * window.CHECKOUT_APP -> objeto reservado para que la app de Contra-Entrega (Releasit COD)
 *   u otra integracion de checkout lea/escriba el estado de cantidad/combo seleccionado.
 */
window.MI_CONFIG = window.MI_CONFIG || { store: 'TuRegalo' };
window.CHECKOUT_APP = window.CHECKOUT_APP || { selectedQty: 1, selectedPriceCents: null };

(function () {
  'use strict';

  function init(root) {
    initGallery(root);
    initFaqSingleOpen(root);
    initReveal(root);
  }

  function initGallery(root) {
    var track = root.querySelector('.licra-cargo-gallery-track');
    var dots = root.querySelectorAll('.licra-cargo-gallery-dot');
    if (!track || !dots.length) return;
    var slides = root.querySelectorAll('.licra-cargo-gallery-slide');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function (s) { io.observe(s); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }

  function initFaqSingleOpen(root) {
    var items = root.querySelectorAll('.licra-cargo-faq-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (o) { if (o !== item) o.open = false; });
        }
      });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.licra-cargo-reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  document.querySelectorAll('.licra-cargo').forEach(init);
})();
